import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { HomePage } from 'components/features/home-page';
import { PageAnnouncer } from 'components/page-announcer';
import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import { PromoMessageRibbon } from 'pages/loyalty/loyalty-promo-message-ribbon';
import useAuthFlow from 'state/auth/hooks/use-auth-flow';
import { useLoyaltyUserState } from 'state/loyalty/hooks/use-loyalty-user-state';
import { useScrollViewFullHeight } from 'state/scroll/hooks';
import { primitive } from 'styles/constants/primitives';
import { isMobile } from 'utils/environment';

const Home = () => {
  useScrollViewFullHeight();
  const { formatMessage } = useIntl();

  const { triggerSignInAccessibility } = useAuthFlow();
  const signInAccessibilityMsg = triggerSignInAccessibility
    ? formatMessage({ id: 'visuallyHiddenSignInSuccess' })
    : '';

  useRumPageView('home', 'Home');

  useLoyaltyUserState({ refreshOnMountOrFocus: true });

  return (
    <Box
      backgroundColor={primitive.bk.$mayoEggWhite}
      flex={1}
      testID="homepage"
      accessibilityLabel={signInAccessibilityMsg}
      accessibilityRole="alert"
    >
      {isMobile() && <PromoMessageRibbon />}
      <HomePage />

      <PageAnnouncer pageTitle={formatMessage({ id: 'homepage' })} />
    </Box>
  );
};

export default Home;
